module.exports = __webpack_public_path__ + "static/cotas-abarcones-din-3570-bad8b4928ea86df9e2c8831489fdcace.pdf";